/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Member_Detail_Standing_InvitedInputs */



/**
* | output |
* | --- |
* | "This member has been invited but has not accepted yet, so they cannot sign in." |
*
* @param {Member_Detail_Standing_InvitedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const member_detail_standing_invited = /** @type {((inputs?: Member_Detail_Standing_InvitedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Member_Detail_Standing_InvitedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieses Mitglied wurde eingeladen, hat die Einladung aber noch nicht angenommen und kann sich daher nicht anmelden.")
	return /** @type {LocalizedString} */ ("This member has been invited but has not accepted yet, so they cannot sign in.")
});